import { AnalyticsKey } from "@/shared/common/enums";
import { analytics } from "app/firebase";
import { logEvent } from "firebase/analytics";
import { useEffect } from "react";

export const useAnalytics = () => {
  const trackButtonClicks = (event: MouseEvent) => {
    const target = event.target as HTMLElement | null;
    if (target?.getAttribute(AnalyticsKey.DataGaId)) {
      const action = target.getAttribute(AnalyticsKey.DataGaAction) || "Unknown Action";
      const label = target.getAttribute(AnalyticsKey.DataGaLabel) ||
        target.getAttribute(AnalyticsKey.DataGaAction);
      const item_id = target.getAttribute(AnalyticsKey.DataGaId) || null;

      logEvent(analytics, action, {
        content_type: label,
        item_id,
      });
    }
  };

  const trackPageView = (pageName: string) => {
    logEvent(analytics, "page_view", { page_title: pageName });
  };

  useEffect(() => {
    document.addEventListener("click", trackButtonClicks);

    return () => {
      document.removeEventListener("click", trackButtonClicks);
    };
  }, []);

  return {
    trackPageView,
  };
};
